import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './symptomLabel.less';
import LabelItem from '../LabelItem/LabelItem';
import { Link } from 'react-router-dom';
// import RadarChart from "../RadarChart/RadarChart";
// import drop from "../../../../../resource/skinReport/drop.png";
import langCommon, { getLangFromLocal } from '../../../../../utils/lang.util';
import { getDateStrByLocal } from '../../../../../utils/date.util';

SymptomLabel.propTypes = {
  data: PropTypes.object,
};

SymptomLabel.displayName = 'SymptomLabel';

function SymptomLabel(props) {
  const { data } = props;

  const [symptom, setSymptom] = useState(data);
  const [lang] = useState(getLangFromLocal());

  const getHash = () => {
    const { search = '?' } = window.location;
    const query = search.substring(1);

    const params = query.endsWith('=') ? query.slice(0, query.length - 1) : query;
    return params;
  };

  useEffect(() => {
    setSymptom(data);
  }, [data]);

  return (
    <div className={styles.symptomLabelWrapper}>
      <div className={styles.symptomLabelArea}>
        <div className={styles.middleWrapper}>
          <div className={styles.titleWrapper}>
            <div>DIAGNOSIS REPORT</div>
            <div className={styles.date}>{getDateStrByLocal({ date: symptom?.created_time, formatType: 'yearmonthday', separator: '/' })}</div>
          </div>
          <Link
            to={{
              pathname: `/my3DImage/${getHash()}`,
              state: { data: symptom, isRawDataNull: true },
            }}
          >
            <img src={symptom?.icon} alt="" />
            {/* <div className={styles.icon}>3D</div> */}
          </Link>
        </div>
      </div>
      <div className={styles.checkStateDegree}>
        <div>{langCommon.severe(lang)}</div>
        <div>{langCommon.moderate(lang)}</div>
        <div>{langCommon.mild(lang)}</div>
        <div>{langCommon.healthy(lang)}</div>
      </div>
      <div className={styles.instanceWrapper}>
        {symptom.instances?.map((item, index) => (
          <LabelItem key={index} item={item?.name} level={item?.level} />
        ))}
      </div>
      {/*<RadarChart data={symptom.instances}/>*/}
    </div>
  );
}

export default SymptomLabel;
